import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import { handleDrawerSuccess, hasArrayErrors } from "@/lib/drawer-submission";

export default function ManageStepCreateDrawer({ step, errors = [], createPath, onSuccess, onProcessingChange = null }) {
  const { data, setData, post, processing } = useForm({
    step: {
      name: step.name || "",
      description: step.description || "",
      index: step.index ?? 0,
      completion_criteria: step.completion_criteria || ""
    }
  });

  useEffect(() => {
    setData({
      step: {
        name: step.name || "",
        description: step.description || "",
        index: step.index ?? 0,
        completion_criteria: step.completion_criteria || ""
      }
    });
  }, [setData, step]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = (event) => {
    event.preventDefault();
    post(createPath, {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_create_step_drawer || hasArrayErrors(props, "step_errors"),
        onSuccess
      )
    });
  };

  return (
    <div className="workspace-content workspace-content--drawer">
      <div className="vstack gap-4 workspace-drawer-form-card card card-body">
        {errors.length > 0 ? (
          <div className="alert alert-danger mb-0">{errors.join(", ")}</div>
        ) : null}

        <form className="workspace-editor-panel vstack gap-3" onSubmit={submit}>
          <div>
            <div className="workspace-section__eyebrow">Implementeringstrin</div>
            <h3 className="workspace-editor-panel__title">Opret trin</h3>
          </div>

          <div className="row g-3 workspace-step-fields-grid">
            <div className="col-lg-8">
              <label className="form-label fw-semibold" htmlFor="manage-new-step-name">Navn</label>
              <input
                id="manage-new-step-name"
                className="form-control"
                value={data.step.name}
                onChange={(event) => setData("step", { ...data.step, name: event.target.value })}
                required
              />
            </div>

            <div className="col-lg-4">
              <label className="form-label fw-semibold" htmlFor="manage-new-step-index">Rækkefølge</label>
              <input
                id="manage-new-step-index"
                className="form-control"
                type="number"
                min="0"
                value={data.step.index}
                onChange={(event) => setData("step", { ...data.step, index: event.target.value })}
                required
              />
            </div>

            <div className="col-12">
              <label className="form-label fw-semibold" htmlFor="manage-new-step-description">Beskrivelse</label>
              <textarea
                id="manage-new-step-description"
                className="form-control"
                rows="3"
                value={data.step.description}
                onChange={(event) => setData("step", { ...data.step, description: event.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="form-label fw-semibold" htmlFor="manage-new-step-completion">Kriterier for at trinnet er løst</label>
              <textarea
                id="manage-new-step-completion"
                className="form-control"
                rows="3"
                value={data.step.completion_criteria}
                onChange={(event) => setData("step", { ...data.step, completion_criteria: event.target.value })}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button className="btn btn-primary" disabled={processing}>Opret trin</button>
          </div>
        </form>
      </div>
    </div>
  );
}
